export default __webpack_public_path__ + "static/media/bo_5.4217f71d.mp3";